import { maskCpfOrCnpj } from '../../../services/masks';

import { ActivationFormState } from '../types';
import { normalizePagarmeBankHolderName } from './activationFormHelpers';

export const applyRecipientTypeChange = <T extends ActivationFormState>(
  prev: T,
  nextRecipientType: ActivationFormState['recipientType']
): T => {
  if (prev.recipientType === nextRecipientType) {
    return prev;
  }

  if (nextRecipientType === 'individual') {
    return {
      ...prev,
      recipientType: nextRecipientType,
      document: '',
      bankHolderType: 'individual',
      bankHolderDocument: '',
      bankHolderName: normalizePagarmeBankHolderName(prev.name)
    };
  }

  const document = prev.document;
  return {
    ...prev,
    recipientType: nextRecipientType,
    document: prev.recipientType === 'individual' ? '' : document,
    bankHolderType: 'company',
    bankHolderDocument: document ? maskCpfOrCnpj(document) : '',
    bankHolderName: normalizePagarmeBankHolderName(
      prev.companyName || prev.tradingName || prev.bankHolderName
    )
  };
};
